import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { langStorage, languages, getCurrentLangName } from '../../../i18n/i18nUtils'
import { useStore } from '../../../StateProvider'
import cn from 'classnames'
import styles from './style.css'
import { useOnClickOutside } from '../../../utils/hooks'

const changeLanguage = i18n => ({ currentTarget }) =>
  i18n.changeLanguage(currentTarget.value, langStorage.callback(currentTarget.value))

const LangMenu = () => {
  const [{ whitelabel: { excludedLanguages } }] = useStore()
  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef()

  const toggle = () => {
    setIsOpen(!isOpen)
  }

  const close = () => {
    setIsOpen(false)
  }

  useOnClickOutside(ref, close)

  return (
    <div className={styles.langMenuWrap} ref={ref}>
      <div className={styles.langTitle} onClick={toggle}>{getCurrentLangName()}</div>
      <div className={cn(styles.innerDropDown, { [styles.isOpen]: isOpen })}>
        <ul className={styles.langGroup}>
          {languages.map(({ code, name }) =>
            <LangItem
              langName={name}
              langCode={code}
              isShown={excludedLanguages.indexOf(code) === -1}
              key={code}
              onItemClick={close}
            />
          )}
        </ul>
      </div>
    </div>
  )
}

const LangItem = ({ langName, langCode, isShown = true, onItemClick }) => {
  const { i18n } = useTranslation()

  const onClick = (event) => {
    changeLanguage(i18n)(event)
    onItemClick()
  }

  return isShown ? (
    <li className={styles.langItem}>
      <button className={styles.langItemBtn} value={langCode} onClick={onClick}>
        {langName}
      </button>
    </li>
  ) : null
}

export { LangMenu }
